import { IVisualizationData } from "common/records/Visualization";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_VISUALIZATION = "@visualizations/RECEIVE_VISUALIZATION";
export const RECEIVE_VISUALIZATIONS = "@visualizations/RECEIVE_VISUALIZATIONS";

export const VisualizationActions = {
  receiveVisualization: (visualization: IVisualizationData) => createAction(RECEIVE_VISUALIZATION, { visualization }),
  receiveVisualizations: (visualizations: IVisualizationData[]) =>
    createAction(RECEIVE_VISUALIZATIONS, { visualizations }),
};

export type VisualizationActions = ActionsUnion<typeof VisualizationActions>;
